<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 24 22">
    <title :id="iconName">{{ iconName }} icon</title>
    <g :fill="iconColor">
      <path
        id="plus-a"
        d="M15.217 10.435h-4.782v4.782a.435.435 0 0 1-.87 0v-4.782H4.783a.435.435 0 0 1 0-.87h4.782V4.783a.435.435 0 0 1 .87 0v4.782h4.782a.435.435 0 0 1 0 .87M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "plus",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 21,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
